<template>
	<div class="ts-space-y-2">
		<fieldset>
			<legend class="text-blue">
				{{ $t('promotion.productLists') }}
				<Tooltip placement="top">
					<Icon type="ios-information-circle-outline" size="17" />
					<div slot="content">
						<div class="ts-text-xs">
							{{ $t('promotion.productLists') }}
						</div>
					</div>
				</Tooltip>
			</legend>
			<div class="ts-space-y-2">
				<div class="row filter">
					<div class="col-md-6">
						<a-select v-model="pro_group_id" :options="productGroups" show-search allowClear
							option-filter-prop="children" class="ts-w-full" style="height: 30px;"
							placeholder="Filter By Group"></a-select>
					</div>
					<div class="col-md-1"></div>
					<div class="col-md-5">
						<input v-model.trim="search" type="text" :placeholder="$t('search')" class="form-control" />
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 overflow-auto">
						<div class="table-ui-detail" style="min-height: 300px; max-height: 420px">
							<table class="ts-w-full" style="max-height: 420px">
								<thead>
									<tr>
										<th width="15%">
											{{ $t('promotion.productGroup') }}
										</th>
										<th width="15%">
											{{ $t('promotion.barcode') }}
										</th>
										<th width="25%">
											{{ $t('promotion.product') }}
										</th>
										<th width="10%">
											{{ $t('promotion.discountType') }}
										</th>
										<th width="10%">
											{{ $t('promotion.discountRate') }}
										</th>
										<th width="10%">
											{{ $t('promotion.incentiveType') }}
										</th>
										<th width="10%">
											{{ $t('promotion.incentiveRate') }}
										</th>
										<th width="5%"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="products.length == 0">
										<td colspan="8" class="ts-text-center ts-p-3 ts-space-x-1">
											<i class="fa fa-folder-open ts-text-gray-200"></i>
											<label class="ts-text-gray-400">
												{{ $t('noData') }}
											</label>
										</td>
									</tr>
									<tr v-else v-for="(product, index) in products" :value="product.product_id"
										:key="index" class="ts-cursor-pointer hover:ts-bg-gray-300">
										<td class="ts-px-2">
											{{ product.pro_group_name_en }}
										</td>
										<td class="ts-px-2">
											{{ product.barcode }}
										</td>
										<td class="ts-px-2">
											{{ product.product_name_en }}
										</td>
										<td>
											<a-select v-model="product.discount_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeItem(product)">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(product.input_currency_id)">
													{{ getDiscountCurrency(product.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>
										<td>
											<input v-if="product.discount_type == '%'" ref="discountRate" type="number"
												v-model.number="product.input_discount_rate" class="form-control"
												@change="onChangeItem(product)" />
											<ts-currency-converter-input v-else
												:input_amount.sync="product.input_discount_rate"
												:amount.sync="product.discount_rate"
												:input_currency_id.sync="product.input_currency_id"
												:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
												:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
										</td>
										<td>
											<a-select v-model="product.incentive_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeItem(product)">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(product.input_currency_id)">
													{{ getDiscountCurrency(product.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>
										<td>
											<input v-if="product.incentive_type == '%'" ref="incentiveRate"
												type="number" v-model.number="product.input_incentive_rate"
												class="form-control" @change="onChangeItem(product)" />
											<ts-currency-converter-input v-else
												:input_amount.sync="product.input_incentive_rate"
												:amount.sync="product.incentive_rate"
												:input_currency_id.sync="product.input_currency_id"
												:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
												:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
										</td>
										<td class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
											<a href="#" class="ts-text-blue-500" @click.prevent="addItem(product)">
												<i class="fa fa-plus"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</fieldset>
	</div>
</template>

<script>
import { includes } from 'lodash';
import { mapState } from 'vuex'
export default {
	name: 'incentiveByItemProductList',
	props: ['value'],
	data() {
		return {
			search: '',
			pro_group_id: undefined,
			model: {}
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		...mapState('promotion/incentiveByItem', ['formViewDatas']),
		products() {
			if (this.formViewDatas['products']) {
				return this.formViewDatas['products']
					.filter(p => this.pro_group_id ? p.pro_group_id == this.pro_group_id : true)
					.filter(p => !includes(this.model.condition.map(el => el.product_id), p.product_id))
					.filter(
						p => this.search
							.split(' ')
							.every(s =>
								p.barcode.toLowerCase().includes(s.toLowerCase())
							) ||
							this.search
								.split(' ')
								.every(s => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
					)
					.slice(0, 40)
			}
			return []
		},
		productGroups() {
			if (this.formViewDatas['productGroups']) {
				return this.formViewDatas['productGroups'].map(el => ({
					value: el.pro_group_id,
					label: el.pro_group_name_en + (el.pro_group_name_kh ? '|' + el.pro_group_name_kh : '')
				}))
			}
			return []
		},
	},
	methods: {
		getDiscountCurrency(input_currency_id) {
			if (this.formViewDatas['currency']) {
				return this.formViewDatas['currency'].find(
					el => el.currency_id == input_currency_id
				).currency_symbol
			}
			return null
		},
		onChangeItem(product) {
			if (product.discount_type == '%') {
				product.discount_rate = product.input_discount_rate
			} else {
				product.discount_type = this.getDiscountCurrency(product.input_currency_id)
				product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
			}

			if (product.incentive_type == '%') {
				product.incentive_rate = product.input_incentive_rate
			} else {
				product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
				product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
			}
		},
		addItem(product) {
			let newItem = {
				product_id: product.product_id,
				currency_id: product.currency_id,
				input_currency_id: product.input_currency_id,
				fx_rate: product.fx_rate,
				fx_rate_ratio: product.fx_rate_ratio,
				discount_type: product.discount_type,
				discount_rate: product.discount_rate,
				input_discount_rate: product.input_discount_rate,
				incentive_type: product.incentive_type,
				incentive_rate: product.incentive_rate,
				input_incentive_rate: product.input_incentive_rate,
			}
			this.model.condition.push(newItem)
		}
	},
}
</script>

<style scoped>
.form-control {
	height: 30px;
}
</style>
<style>
.filter .ant-select-selection--single {
	height: 29px;
}
</style>